module.exports = __webpack_public_path__ + "images/emoji/performing_arts.f4f3a612b263246567f4.png";